export const enum Tasks {
  startUp = '0',
  jumpIn = '1',
  idealLine = '2'
}
